
import GwBlock from '~/patterns/atoms/block/block.vue';

export default {
    components: {
        GwBlock
    }
};
